<ng-container *ngIf="blurHash; else DEFAULT">
  <img class="blur-hash" [src]="blurHash" alt="" />
</ng-container>

<ng-template #DEFAULT>
  <div class="loader-content">
    <ng-content select="[xLoaderContent]"></ng-content>
  </div>

  @switch (loader) {
    @case ('dot-flashing') {
      <div class="dot-flashing-container {{ size }}">
        <div
          *ngFor="let dot of dotsArray; let i = index"
          class="dot-flashing {{ theme }}"
          [style.animation-delay]="i * 0.2 + 's'"
        ></div>
      </div>
    }
    @default {
      <div [class]="loader + ' ' + theme + ' ' + size"></div>
    }
  }
</ng-template>
